import React, { useEffect, useState } from 'react';
import { TrialContentContext } from '../context/ContentContext';
import { getSiteCoreContent } from '../services/sitecoreServices';
import { getCookie } from '../util/cookies';
import { gtagEnvelope } from '../util/gtagEnvelope';

export const TrialContentProvider = ({ children }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    const checkCookie = () => {
      const cookie = getCookie('lastpassConsentDecision');
      if (cookie) {
        setTimeout(() => {
          getContent();
        }, 500);
      } else {
        setTimeout(() => {
          checkCookie();
        }, 500);
      }
    };

    checkCookie();

    return () => {};
  }, []);

  const getContent = () => {
    getSiteCoreContent()
      .then((result) => {
        if (result.status !== 200) {
          setData(false);
        }

        setData(result.data);
      })
      .catch((error) => {
        gtagEnvelope('event', 'trial_page_error', {
          error_type: 'runtime_error',
          error_code: 500,
          error_message: `Trial content loading ${error.message}`,
        });
        setData(false);
      });
  };

  return <TrialContentContext.Provider value={data}>{children}</TrialContentContext.Provider>;
};
